<template>
  <SimpleForm v-bind="getBindValue" @register="emitRegister">
    <template v-for="item in Object.keys($slots)" #[item]="data">
      <slot :name="item" v-bind="data || {}"></slot>
    </template>
  </SimpleForm>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { Recordable } from '@mts-fe/types';
  import {
    FormActionType,
    FormProps,
    FormSchemaInner,
    SimpleForm,
    useForm,
  } from '@mts/components/Form';
  import { FORM_EMIT_EVENTS, useFormEvents } from '@mts/render/hooks/useRenderForm';

  defineOptions({
    name: 'ReadonlyForm',
  });

  const props = withDefaults(
    defineProps<Omit<FormProps, 'schemas'> & { schemas?: FormSchemaInner[] }>(),
    {
      name: 'readonly-form',
      readonlyMode: true,
      strongRelate: true,
      autoSetPlaceHolder: true,
      rulesMessageJoinLabel: true,
      showResetButton: true,
      showSubmitButton: true,
      compact: true,
    },
  );
  const emit = defineEmits(['register', ...FORM_EMIT_EVENTS]);
  const bindFormEvents = useFormEvents(emit);
  const [registerForm, formAction] = useForm();
  const emitRegister = (...args: Recordable[]) => (
    registerForm(args[0] as FormActionType),
    emit('register', ...args)
  );
  defineExpose(formAction);

  const getBindValue = computed(() => {
    return {
      ...props,
      ...bindFormEvents,
      schemas: props.schemas?.map((i) => ({
        ...i,
        component: !i.slot && (i.component || 'ReadonlyText'),
      })),
    };
  });
  // console.log({ ...getBindValue.value });
</script>
